import type { TSimulacaoSacocVOutput } from '@/features/simulacao/interfaces/simulacao.type'
import { HttpService } from '@/infra/http'
import type { TTipoProdutoValidoEnum } from '@/types/produto'
import type { TEmpreendimentoSimulacao, TFormaDePagamentoEnum, TTipoAmortizacaoEnum } from '@/types/simulacao'
import type { TGrupoParcelasToUTC } from '@/utils/grupo-parcelas.utils'
import type { TGrupoParcelasIntermediarias } from '@/utils/grupos-parcelas-api.mapper'

export type TGetSimulacaoDuplicarResponse = {
  id: string
  dataSimulacao: string
  tipoDeAmortizacao: TTipoAmortizacaoEnum | null
  empreendimento: TEmpreendimentoSimulacao
  produto: { id: string; idExterno: number; tipoDoProduto: TTipoProdutoValidoEnum }
  bloco: { id: string; idExterno: number; previsaoDeEntrega: string }
  entrada: TGrupoParcelasToUTC['parcelas']
  mensais: TGrupoParcelasToUTC[]
  intermediarias: TGrupoParcelasIntermediarias[]
  intermediariasPosConclusao: TGrupoParcelasIntermediarias[] | null
  saldo: TGrupoParcelasToUTC['parcelas'][number] | null
  posConclusao: TGrupoParcelasToUTC['parcelas']
  formaDePagamento?: TFormaDePagamentoEnum | null
}

export type TSimuladorLocationState = {
  empreendimento: TEmpreendimentoSimulacao
  idExternoProduto: number
  idExternoBloco: number
  tipoDoProduto: TTipoProdutoValidoEnum
  simulacao?: TSimulacaoSacocVOutput['simulacao']
  simulacaoDuplicada?: TGetSimulacaoDuplicarResponse
}

export class GetSimulacaoDuplicarService extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacaoDuplicarResponse>(`/api/v2/Simulacao/${simulacaoId}/duplicar`)
  }
}
